"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _joiBrowser = _interopRequireDefault(require("joi-browser"));

var _HttpService = _interopRequireDefault(require("../HttpService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ApiKeyService = /*#__PURE__*/function () {
  function ApiKeyService() {
    _classCallCheck(this, ApiKeyService);
  }

  _createClass(ApiKeyService, null, [{
    key: "getApiKey",
    value: function getApiKey(tenant) {
      return this.httpService.get("".concat(tenant, "/apiKeys"));
    }
  }, {
    key: "rollApiKey",
    value: function rollApiKey(tenant, expirationDate) {
      if (expirationDate !== null && expirationDate !== undefined && _joiBrowser["default"].validate(expirationDate, _joiBrowser["default"].date().iso()).error !== null) {
        return Promise.reject(new Error('Missing Expiration Date'));
      }

      return this.httpService.get("".concat(tenant, "/rollApiKeys?expirationDate=").concat(expirationDate));
    }
  }]);

  return ApiKeyService;
}();

exports["default"] = ApiKeyService;
ApiKeyService.httpService = new _HttpService["default"]({
  baseURL: "".concat(typeof window !== 'undefined' ? env.REACT_APP_TENANT_API : '', "/tenants")
});